import React from "react";
import uuid from "react-uuid";
import uodaLogo from "../images/uodalogo.png";


const Credential = () => {
  const credentials = [
    {
      degree: "BSc. in Computer Science & Engineering (CSE)",
      institute: "University Of Development Alternative",
      year: "April 2017 - April 2021",
      logo: uodaLogo,
      website:"",
    },
    // {
    //   degree: "Higher Secondary School Certificate",
    //   institute: "Godagari Model School & College",
    //   year: " Passing Year - 2016",
    //   logo: gsandclogo,
    //   website:"",
    // },

  ];

  return (
    <div className="credential">
      <div className="section-heading">
        <h4>Credentials</h4>
      </div>
      <div className="companies">
        {
          credentials.map(cred => 
          <div key={uuid()} className="company-position">
            <div className="company-logo">
              <a href={cred.website}> <img src={cred.logo} alt="" /></a>
            </div>
            <div className="employee-details">
              <h5>{cred.degree}</h5>
              <p>{cred.institute}</p>
              <h6>{cred.year}</h6>
            </div>
          </div>  
          )
        }
      </div>
    </div>
  );
};

export default Credential;
